import React from "react"
import { ShieldBan } from "lucide-react"
import { Card, CardContent } from "../components/ui/card"

const NotAvailable = () => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Blur + darken EVERYTHING behind */}
      <div className="fixed inset-0 z-0 backdrop-blur-xl bg-black/60" />

      {/* Centered card */}
      <div className="relative z-10 min-h-screen flex items-center justify-center px-4 py-16">
        <Card className="w-full max-w-2xl !bg-[#1A1D21]/50 border-[#2A2D31] backdrop-blur-sm overflow-hidden relative">
          <div className="absolute inset-0 !bg-gradient-to-br from-[#FF6B00]/10 to-transparent" />
          <CardContent className="p-8 md:p-12 relative text-center">
            <div className="mx-auto mb-6 w-16 h-16 rounded-2xl !bg-[#FF6B00]/10 flex items-center justify-center">
              <ShieldBan className="h-8 w-8 text-[#FF6B00]" />
            </div>

            <h1 className="text-3xl md:text-4xl font-bold mb-4 font-display bg-gradient-to-r from-[#FF6B00] via-[#FF9A3D] to-[#FFD700] bg-clip-text text-transparent drop-shadow-glow">
              Unavailable in your region
            </h1>

            <p className="text-blue-100/80 text-lg max-w-2xl mx-auto">
              Users from this country are not allowed to access this website.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default NotAvailable
